import moment from 'moment'
/**
 * json 对象转换为sql的where 条件
 * 区间用数组，包含边界值
 * 只支持一层数据结构
 * @param {*} object
 */
export function convertSqlWhere(params) {
  return Object.keys(params).map(item => {
    const value = params[item]
    if (value) {
      // "number"，"string"，"boolean"，"object"，"function"，"undefined"
      // console.log(Object.prototype.toString.call("jerry"));//[object String]
      // console.log(Object.prototype.toString.call(12));//[object Number]
      // console.log(Object.prototype.toString.call(true));//[object Boolean]
      // console.log(Object.prototype.toString.call(undefined));//[object Undefined]
      // console.log(Object.prototype.toString.call(null));//[object Null]
      // console.log(Object.prototype.toString.call({name: "jerry"}));//[object Object]
      // console.log(Object.prototype.toString.call(function(){}));//[object Function]
      // console.log(Object.prototype.toString.call([]));//[object Array]
      // console.log(Object.prototype.toString.call(new Date));//[object Date]
      // console.log(Object.prototype.toString.call(/\d/));//[object RegExp]
      // function Person(){};
      // console.log(Object.prototype.toString.call(new Person)); //[object Object]
      // console.log('sqlUtil', Object.prototype.toString.call(value)) //[object Object]
      switch (Object.prototype.toString.call(value)) {
        case '[object String]':
          if (item.endsWith('_like')) {
            const names = item.split('_like')
            return `${names[0]} like '%${value}%'`
          }
          return `${item}='${value}'`
        case '[object Number]':
          return `${item}=${value}`
        case '[object Boolean]':
          return `${item}='${value}'`
        case '[object Array]':
          if (value[0] && Object.prototype.toLocaleString.call(value[0]) === '[object Date]') {
            return `${buildDatePropertyCompare(item)} between ${buildDateValueCompare(moment(value[0]))} and ${buildDateValueCompare(moment(value[1]))}`
          } else if (isMoment(value[0])) {
            return `${buildDatePropertyCompare(item)} between ${buildDateValueCompare(value[0])} and ${buildDateValueCompare(value[1])}`
          } else if (item.endsWith('_in')) {
            return `${item.split('_')[0]} in (${value.join(',')})`
          } else {
            if (value[0] && value[1]) {
              return `${item} between ${value[0]} and ${value[1]}`
            } else {
              return null
            }
          }
        case '[object Date]':
          return `${buildDatePropertyCompare(item)} = ${buildDateValueCompare(moment(value))}`
        case '[object Object]':
          if (isMoment(value)) {
            return `${buildDatePropertyCompare(item)} = ${buildDateValueCompare(value)}`
          } else {
            return null
          }
        case '[object Undefined]':
          return null
        case '[object Null]':
          return null
        case '[object Function]':
          return null
        default:
          return null
      }
    }
  }).filter(item => item != null).join(' and ')
}

function isMoment(o) {
  // console.log('判断moment', o) // 返回true
  if (o) {
    return o._isAMomentObject
  } else {
    return false
  }
}

// 将日期转换成数字字符串发送
function buildDatePropertyCompare(propertyname) {
  return `(YEAR(${propertyname}) * 12 * 31 + MONTH(${propertyname}) * 31 + DAY(${propertyname}))`
}
function buildDateValueCompare(moment) {
  return moment.year() * 12 * 31 + (moment.month() + 1) * 31 + moment.date()
}
export default { convertSqlWhere }
